import { render } from "./court-inactive.vue?vue&type=template&id=2d49a2cc"
import script from "./court-inactive.vue?vue&type=script&lang=js"
export * from "./court-inactive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__